import React from 'react'
import { ToolkitPageLayout } from '../../components'
import { Link } from 'react-router-dom'
import { ToolkitGenericPlaceholderImage } from 'assets'

// Assuming image assets will be handled similarly to ToolkitHome,
// though specific images for this page are not in the provided JSON snippet directly.
// We'll need to define paths or import if images are part of the content.
// For now, using placeholder class names for WP image blocks if they appear.

export const ProvidersTrainingPage: React.FC = () => {
  return (
    <ToolkitPageLayout
      title="Sickle Cell Disease Training"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Providers', path: '/toolkit/providers' }, // Assuming a general providers landing page might exist
        { label: 'Training Modules', path: '/toolkit/providers/training' } // Current page, path is still useful
      ]}
    >
      <div className="space-y-6">
        {/* Column 1 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
          <div className="flex flex-col items-center text-center">
            <img
              src="https://www.dropbox.com/scl/fi/w0l2ytnndxqqxew3qyznn/Screen-Shot-2021-02-24-at-11.45.47-AM.png?rlkey=ctyqh2wqe63b8xlhqmuemz6f9&dl=0&dl=1"
              alt="Cultural Competency Training"
              className="mb-2 rounded-lg h-48 w-full object-contain"
            />
            <Link
              to="/toolkit/shared/cultural-competency-training"
              state={{ from: 'providers' }}
              className="text-lg font-semibold text-[#A6410A] hover:text-[#894d35]"
            >
              Cultural Competency Training
            </Link>
          </div>

          <div className="flex flex-col items-center text-center">
            <img
              src={ToolkitGenericPlaceholderImage}
              alt="Social Determinants of Health Training"
              className="mb-2 rounded-lg h-48 w-full object-contain"
            />
            <Link
              to="/toolkit/shared/social-determinants-health-training"
              state={{ from: 'providers' }}
              className="text-lg font-semibold text-[#A6410A] hover:text-[#894d35]"
            >
              Social Determinants of Health Training
            </Link>
          </div>
        </div>

        {/* Column 2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
          <div className="flex flex-col items-center text-center">
            <img
              src={ToolkitGenericPlaceholderImage}
              alt="Pain Management Strategies Training"
              className="mb-2 rounded-lg h-48 w-full object-contain"
            />
            <Link
              to="/toolkit/shared/pain-management-training"
              state={{ from: 'providers' }}
              className="text-lg font-semibold text-[#A6410A] hover:text-[#894d35]"
            >
              Pain Management Strategies Training
            </Link>
          </div>

          <div className="flex flex-col items-center text-center">
            <img
              src={ToolkitGenericPlaceholderImage}
              alt="Sickle Cell Disease Modifying Treatments"
              className="mb-2 rounded-lg h-48 w-full object-contain"
            />
            <Link
              to="/toolkit/shared/scd-modifying-treatments"
              state={{ from: 'providers' }}
              className="text-lg font-semibold text-[#A6410A] hover:text-[#894d35]"
            >
              Sickle Cell Disease Modifying Treatments
            </Link>
          </div>
        </div>
        {/* WP Buttons block - typically for navigation, might not be needed if links above suffice */}
        {/* <div className="wp-block-buttons"></div> */}
        <p>
          {/* Empty paragraph from original content, can be removed if not needed */}
        </p>
      </div>
    </ToolkitPageLayout>
  )
}
